import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import { Container, Box, Button, CircularProgress } from '@mui/material';
import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import OrderSummary from '../components/OrderSummary';
import { httpsCallable } from "firebase/functions";
import { functions } from '../firebase';
import { useData } from '../Form';
import { useStep } from '../Form';

const createOrder = httpsCallable(functions, 'createOrder');
const captureOrder = httpsCallable(functions, 'captureOrder');
const registerParticipant = httpsCallable(functions, 'registerParticipant');
// Renders errors or successfull transactions on the screen.

export default function PaymentForm() {
  const { data, updateData, clearData } = useData()
  const { decrementStep, firstStep } = useStep()
  const [message, setMessage] = useState('');
  const [{ isPending }] = usePayPalScriptReducer();

  async function storeData(data) {
    try {
      const docRef = await registerParticipant({data: data})
      return docRef.id; // Return the document ID
    } catch (error) {
      console.error("Error adding document: ", error);
      throw error; // Optionally re-throw the error for the caller to handle
    }
  }

  function calcSum() {
    let sum = data.products.reduce((n, { unit_amount }) => n + unit_amount.value, 0)
    if (data.hasFinancialSupport) {
      sum = sum - data.financialSupportAmount
    }
    sum -= (Number(data.discountCodeAmountOff) || 0)
    return sum
  }

  return (
    <React.Fragment>
      {data.hasPaid ?
        <Container>
          <Typography variant="h5">
            Thank you for signing up!
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
            <Button
              variant="contained"
              onClick={() => {
                clearData()
                firstStep()
              }}
              sx={{ mt: 3 }}
            >
              Register another participant
            </Button>
          </Box>
        </Container>
        : <>
          <OrderSummary />
          {calcSum() > 0 ?
            <>
              <Container maxWidth="sm" sx={{ marginTop: 4 }}>
                {isPending ? <CircularProgress /> : null}
                <PayPalButtons style={{ layout: "vertical" }}
                  createOrder={async () => {
                    try {
                      console.log(data.products)
                      //const docRef = await storeData({ ...data, ...{ timeStamp: moment().format('MM/DD/YYYY hh:mm A') } }) // first store the data on firestore to ensure it gets captured
                      // Update local data object with docRef
                      const result = await createOrder({
                        products: data.products,
                        discount: (data.hasFinancialSupport ? Number(data.financialSupportAmount) : 0)
                          + (Number(data.discountCodeAmountOff) || 0)
                      })
                      const orderData = result.data

                      if (orderData.id) {
                        //let newData = { ...data, ...{hasPaid: false, orderID: orderData.id } }
                        //storeData(newData)
                        updateData({ orderID: orderData.id })
                        return orderData.id;
                      }

                      else {
                        const errorDetail = orderData?.details?.[0];
                        const errorMessage = errorDetail
                          ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                          : JSON.stringify(orderData);

                        throw new Error(errorMessage);
                      }
                    } catch (error) {
                      console.error(error);
                      setMessage(
                        `Could not initiate PayPal Checkout...${error}`
                      );
                    }
                  }}
                  onApprove={async (dataPaypal, actions) => {
                    try {
                      console.log(dataPaypal.orderID)
                      const result = await captureOrder({
                        orderID: dataPaypal.orderID,
                        data: data,
                      })
                      const orderData = result.data
                      console.log(orderData)
                      // Three cases to handle:
                      //   (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                      //   (2) Other non-recoverable errors -> Show a failure message
                      //   (3) Successful transaction -> Show confirmation or thank you message
                      const errorDetail = orderData?.details?.[0];

                      if (errorDetail?.issue === 'INSTRUMENT_DECLINED') {
                        // (1) Recoverable INSTRUMENT_DECLINED -> call actions.restart()
                        // recoverable state, per https://developer.paypal.com/docs/checkout/standard/customize/handle-funding-failures/
                        return actions.restart();
                      } else if (errorDetail) {
                        // (2) Other non-recoverable errors -> Show a failure message
                        throw new Error(
                          `${errorDetail.description} (${orderData.debug_id})`
                        );
                      } else {
                        // (3) Successful transaction -> Show confirmation or thank you message
                        // Or go to another URL:  actions.redirect('thank_you.html');

                        /*const transaction = orderData.purchase_units[0].payments.captures[0];
                        setMessage(
                          `Transaction ${transaction.status}: ${transaction.id}. See console for all available details`
                        );
                        */
                        updateData({ hasPaid: true, orderID: orderData.id })
                      }
                    } catch (error) {
                      console.error(error);
                      setMessage(
                        `Sorry, your transaction could not be processed...${error}`
                      );
                    }
                  }} />
                <Typography variant="h6" gutterBottom>
                  {message}
                </Typography>
              </Container>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant="contained"
                  onClick={decrementStep}
                  sx={{ mt: 3, ml: 1 }}
                >
                  Back
                </Button>
              </Box>
            </>
            : <Container>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  onClick={decrementStep}
                  sx={{ mt: 3, mr: 1 }}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  onClick={() => {
                    updateData({ hasPaid: true })
                    storeData({ ...data, ...{ hasPaid: true } })
                  }}
                  sx={{ mt: 3, mr: -3 }}
                >
                  Click to submit your registration form
                </Button>
              </Box>
            </Container>}
        </>}
    </React.Fragment>
  );
}
